import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

export default function FAQSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
            — Frequently Asked
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
            Questions welders ask us.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-neutral-200 rounded-xl px-6 bg-neutral-50/60 data-[state=open]:bg-white data-[state=open]:border-neutral-300"
            >
              <AccordionTrigger className="text-left font-display text-lg font-semibold text-[#0b0b0d] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-600 leading-relaxed pb-6 text-[15px]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
